import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';

// custom hook for reusable error alert component
// reduces boilerplate of setting alert properties and displaying errors
// can provide default title (alertAction) and error message (alertMessage)
// and control when to show alert (showAlert) and when to automatically close (timer)

const ErrorAlert = (errorAlertProps) => {
    const { alertAction, alertMessage, handleClose } = errorAlertProps;

    return (
        <Alert onClose={handleClose} variant="danger" dismissible>
            <Alert.Heading>{alertAction}</Alert.Heading>
            <p>{alertMessage}</p>
        </Alert>
    );
};

export function useErrorAlert({ alertAction = '', alertMessage = '' } = {}) {
    const [error, setError] = useState({ showAlert: false, alertAction, alertMessage });

    const handleClose = () => setError((prevError) => ({ ...prevError, showAlert: false }));

    // by default, shows the alert unless otherwise specified
    const setAlertError = (alertError) => {
        setError((prevError) => ({ ...prevError, showAlert: true, ...alertError }));

        const { timer } = alertError;
        if (timer && timer > 0) setTimeout(handleClose, timer);
    };

    const errorAlertProps = { ...error, handleClose };

    return { alertError: error, setAlertError, ErrorAlert, errorAlertProps };
}
